import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash'
import { MasterSummaryPDModel, MasterSummaryQuestionModel } from '../../../../models/survey/survey.model';
import { SortType } from '../../../constants/sort.constants';
import { CHART_COLORS } from '../../../helpers/chart-helper';
import { CommunicationService } from '../../../services/communication.service';

@Component({
  selector: 'app-comparative-bar-chart',
  templateUrl: './comparative-bar-chart.component.html',
  styleUrls: ['./comparative-bar-chart.component.less']
})
export class ComparativeBarChartComponent implements OnInit {

  @Input() dataSource: MasterSummaryPDModel;
  @Input("chartJ") chartJ: number;
  @Input() isSelectedAllResponses: boolean;

  questionModel: MasterSummaryQuestionModel;

  chartInstance: any;
  isLoading = false;
  chartOption: any;
  oldDataSource: string;
  sortType = SortType.RESET;
  initOpts = {
    renderer: 'svg',
    width: 660,
    height: 400
  };
  
  constructor(private communicationService: CommunicationService) {
  }

  ngOnInit() {
    this.communicationService.scrollDataChanged.subscribe(() => {
        if (this.oldDataSource !== JSON.stringify(this.dataSource)) {
          this.oldDataSource = JSON.stringify(this.dataSource);
          this.initChart();
        }
    });
    this.communicationService.sortCompareChartsChanged.subscribe((response) => {
      if(response.sortType !== this.sortType) {
        this.sortType = response.sortType;
        if (this.sortType === SortType.RESET) {
          this.initChart();
        } else {
          this.reloadChart();
        }
      }
    });
    this.initChart();
  }

  onChartInit(instance) {
    this.chartInstance = instance;
  }

  private reloadChart() {
    if (this.chartInstance && this.chartOption) {
      if (this.chartOption.series && this.chartOption.series.length > 1) {
        if (this.questionModel && this.questionModel.listAnswerModel) {
          const sortOrder = this.sortType === SortType.ASCENDING ? 'asc' : 'desc';
          const answers = _.orderBy(this.questionModel.listAnswerModel, ['answerDiffPercentage'],[sortOrder]);
          
          let categories = [];
          let diffPercentageData = [];
          let dataSeries = [];
          let option = this.chartOption;
          let optionSeries = option.series[1].data;
          for (let i = 0; i < answers.length; i++) {
            const answer = answers[i];
            const data = _.find(optionSeries, function(o) { return o.name === answer.answerName; });
            categories.push(answer.answerName);
            diffPercentageData.push(answer.answerDiffPercentage)
            dataSeries.push({
              value: answer.answerDiffPercentage,
              name: answer.answerName,
              itemStyle: {color: data.itemStyle.color},          
            });
          }
          option.yAxis[0].data = categories;
          option.yAxis[1].data = diffPercentageData;
          option.series[1].data = dataSeries;
          this.chartInstance.setOption(option);
        }
      }
    }
  }

  private initChart() {
    this.isLoading = true;
    let chartHeight = 0;
    const barHeight = 40;    
    
    let question = this.dataSource.listQuestionModel[this.chartJ];

    let categories = [];
    let diffPercentageData = [];
    let dataSeries = [];
    
    if (this.isSelectedAllResponses) {
      if (this.dataSource.listSurveyVersionQuestion.length > 0) {
        question = this.dataSource.listSurveyVersionQuestion[0].listQuestionModel[this.chartJ];
      } else if (this.dataSource.listSurveyCutQuestion.length > 0) {
        question = this.dataSource.listSurveyCutQuestion[0].listQuestionModel[this.chartJ];
      }
    } else {
      if (this.dataSource.listSurveyVersionQuestion.length === 1 && this.dataSource.listSurveyVersionQuestion.length === 1) {
        question = this.dataSource.listSurveyCutQuestion[0].listQuestionModel[this.chartJ];
      } else {
        if (this.dataSource.listSurveyVersionQuestion.length > 1) {
          question = this.dataSource.listSurveyVersionQuestion[1].listQuestionModel[this.chartJ];
        } else if (this.dataSource.listSurveyCutQuestion.length > 1) {
          question = this.dataSource.listSurveyCutQuestion[1].listQuestionModel[this.chartJ];
        }
      }
    }

    if (question) {
      this.questionModel = question;
      let colorIndex = 0;

      for (let i = 0; i < question.listAnswerModel.length; i++) {
        const answer = question.listAnswerModel[i];
        
        categories.push(answer.answerName);
        diffPercentageData.push(answer.answerDiffPercentage)

        dataSeries.push({
          value: answer.answerDiffPercentage,
          name: answer.answerName,
          itemStyle: {color: CHART_COLORS[colorIndex]},          
        });
        colorIndex++;
        if (colorIndex === CHART_COLORS.length) {
            colorIndex = 0;
        }
      }
      this.isLoading = false;
    }
    
    chartHeight = categories.length * (barHeight + 10);
    this.initOpts.height = chartHeight + 40;
  
    this.chartOption = {
      animation: false,
      height: chartHeight,
      grid: {
        width: 440,
        top: 20,
        right: 0,
        bottom: 30,
        left: 160,
      },
      
      tooltip: {
        trigger: 'axis',
        borderRadius: 0,
        shadowColor: null,
        borderColor: '#5E5E5E',
        axisPointer: {
          type: 'shadow'
        },
        formatter: (params) => {
          return params[0].axisValue;
        },        
      },
      
      xAxis: {
        type: 'value',
        axisLabel: {
          show: false
        },
        splitLine: {
          show: false
        },
        min: -100,
        max: 100
      },
      yAxis: [
        {
          type: 'category',
          data: categories,
          position: 'left',
          inverse: true,
          axisLabel: {
            formatter: '{value}',
            width: 150,
            align: 'right',
            overflow: 'truncate',
            ellipsis: '...'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        {
          type: 'category',
          data: diffPercentageData,
          align: 'right',
          inverse: true,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: function(value) {
              if (!isNaN(value)) {
                if (Number(value) === 0) {
                  return '0%';
                } else if (value > 0) {
                  return value + '% ' + '↑';
                } else {
                  return -value + '% ' + '↓';
                }
              }
              return '';
            },
            color: function(value, index) {
              if (!isNaN(value)) {
                if (Number(value) === 0) {
                  return 'black';
                } else if (value > 0) {
                  return '#04AA6D';
                } else {
                  return '#FF0000';
                }
              }
            }
          }
        },
      ],
      series: [
        {
          name: 'splitLine',
          type: 'bar',
          markLine: {
              silent: true,
              symbol: 'none',
              label: {
                  show: false
              },
              data: [
                  {
                      xAxis: 0,
                      lineStyle: {
                          color: '#AAAAAA',
                          width: 1,
                          type: 'dashed'
                      },
                      label: {
                        show: false
                      }
                  },
              ]
          }
        },
        {
          name: 'mainChart',
          type: 'bar',
          barWidth: barHeight + 'px',
          barGap: 0,
          showBackground: 'true',
          label: {
            show: false,
          },
          data: dataSeries,
        }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/comparative-bar-chart/comparative-bar-chart.component.ts